import { render, staticRenderFns } from "./SetDataAccessForm.vue?vue&type=template&id=71723764&"
import script from "./SetDataAccessForm.vue?vue&type=script&lang=js&"
export * from "./SetDataAccessForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports